import createStore from '@/stores/store';

interface TimelineActionsState {
  isCreatingChapter: boolean;
  isAddingImage: boolean;
  isAddingVideo: boolean;
  isAddingAudio: boolean;
}

/**
 * This store is used to manage temporary state required for actions in the timeline.
 * Examples include:
 * - Loading states
 * - Popup visibility states
 * - Drag operation indicators
 * - Chapter creation mode
 * - Other transient UI states related to timeline interactions
 */
export const timelineActionsStore = createStore<TimelineActionsState>({
  isCreatingChapter: false,
  isAddingImage: false,
  isAddingVideo: false,
  isAddingAudio: false
});

export function startChapterCreation() {
  timelineActionsStore.set(state => ({
    ...state,
    isCreatingChapter: true
  }));
}

export function endChapterCreation() {
  timelineActionsStore.set(state => ({
    ...state,
    isCreatingChapter: false
  }));
}

export function setIsAddingImage(isAddingImage: boolean) {
  timelineActionsStore.set(state => ({
    ...state,
    isAddingImage
  }));
}

export function setIsAddingVideo(isAddingVideo: boolean) {
  timelineActionsStore.set(state => ({
    ...state,
    isAddingVideo
  }));
}

export function setIsAddingAudio(isAddingAudio: boolean) {
  timelineActionsStore.set(state => ({
    ...state,
    isAddingAudio
  }));
}
